import React, { useState, useEffect, useRef, Fragment } from "react";

import { 
    Container, 
    Row, 
    Col, 
    Button, 
    Card, 
    CardBody, 
    Form, 
    FormGroup, 
    Label, 
    Input, 
    Alert 
} from "reactstrap";

// core components
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Contact(props) {

    const [ form, setForm ] = useState({
        first: '',
        last: '',
        email: '',
        organization: '',
        website: '',
        members: 'Less than 1000',
        message: '',
    });

    const [ loading, setLoading ] = useState(false);
    const [ formSubmitted, setFormSubmitted ] = useState(false);

    const [ errors, setErrors ] = useState({});
    const [ errorMessage, setErrorMessage ] = useState(null);

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | Contact our Sales Team to begin our Journey Together"
        document.querySelector('meta[name="description"]').setAttribute("content", "Our sales team is eager to tell you how Club Apps can help your organization succeed in the digital age. We can't wait to begin our relationship with you and your organization.");
    }, []);

    const handleChange = name => event => {

        setErrorMessage(null);

        const target = event.target;
        const value = (target.type === 'checkbox' ? target.checked : target.value);

        if (isError(name)) delete errors[name];

        setForm({ ...form, [name]: value });
    };

    const postForm = e => {

        e.preventDefault();
        setErrors({});
        setErrorMessage(null);

        let newErrors = {};

        if (form.email === null || form.email === "" || ! validEmail(form.email)) {
            newErrors.email = 'Please provide a valid email address.';
        }

        if (form.first === null || form.first === "") {
            newErrors.first = 'We need your first name to properly address you.';
        }

        if (form.last === null || form.last === "") {
            newErrors.last = 'We need your last name to properly address you.';
        }

        if (Object.keys(newErrors).length === 0) {
            
            setLoading(true);

            _agile.create_contact({email: form.email}, {
                success: postContactDetails,
                error: postContactDetails
            });
        } else {
            setErrors(newErrors);
            setErrorMessage("Looks like you missed some required fields.")
        }
    }

    const postContactDetails = () => {
        
        _agile.set_email(form.email);

        const company = {
            name: form.organization,
            url: form.website,
            members: form.members
        };

        _agile.create_company(company, {
            success: () => {
                const contact = {
                    first_name: form.first,
                    last_name: form.last,
                    company: form.organization,
                    sales_form_message: form.message 
                }
                _agile.update_contact(contact);
            }
        });

        const task = {};
        const today = new Date();
        const date = new Date();

        date.setDate(today.getDate() + 2);

        task.type = "FOLLOW_UP";
        task.priority_type = "HIGH";
        task.subject = "Follow up with contact from website sales form.";
        task.due = date.getTime();

        _agile.add_task(task);

        _agile.add_tag('Contacted Sales, Newsletter', {
            success: () => {
                setLoading(false);
                setFormSubmitted(true);
            },
            error: () => {
                setErrorMessage("Looks like we have experienced an error. Please try again later or email us at sales@clubapps.org.");
                setLoading(false);
            }
        });
    }

    const validEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    return (
        <Fragment>
            <AppNavbar white />
            <main ref={mainEl}>
                <section className="section">
                    <Container className="pb-3 pb-lg-9 mt-md-5">
                        <Row className="row-grid align-items-center">
                            <Col className="text-center d-none d-md-block" md="5">
                                <img
                                    alt="Sales Associates are waiting"
                                    height="190"
                                    src={require("assets/images/sales-associate.png")}
                                />
                            </Col>
                            <Col md="7">
                                <h2 className="display-4">
                                    Contact our Sales Team
                                </h2>
                                <p className="lead text-muted">
                                    We are happy to answer any questions you may have, for instance why the sky is blue... although that's a tough one... any way go ahead and fill out the form and we will be in touch as soon as possible.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="0 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row>
                            <Col md="12" lg="7">
                                <Card className="card-form shadow shadow-lg--hover mt--200">
                                    <CardBody className="py-5">
                                        {formSubmitted ? (
                                            <Alert color="success" className="mb-0">
                                                Thank you for contacting Club Apps. A member of our team should be reaching out to you shortly regarding your request.
                                            </Alert>
                                        ) : (
                                            <Form id="agile-form">
                                                <FormGroup row>
                                                    <Label for="sales-input-first" lg={3}>First Name</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            required
                                                            type="text"
                                                            name="first"
                                                            id="sales-input-first"
                                                            placeholder="Harry"
                                                            value={form.first}
                                                            onChange={handleChange('first')}
                                                            className={isError('first') ? 'is-invalid' : ''}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="sales-input-last" lg={3}>Last Name</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            required
                                                            type="text"
                                                            name="last"
                                                            id="sales-input-last"
                                                            placeholder="Potter"
                                                            value={form.last}
                                                            onChange={handleChange('last')}
                                                            className={isError('last') ? 'is-invalid' : ''}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="sales-input-email" lg={3}>Email</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            required
                                                            type="email"
                                                            name="email"
                                                            id="sales-input-email"
                                                            placeholder="harry.potter@gryffindor.org"
                                                            value={form.email}
                                                            onChange={handleChange('email')}
                                                            className={isError('email') ? 'is-invalid' : ''}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <hr/>
                                                <FormGroup row>
                                                    <Label for="sales-input-organization" lg={3}>Organization</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            type="text"
                                                            name="organization"
                                                            id="sales-input-organization"
                                                            placeholder="Harry Potter Fan Club"
                                                            value={form.organization}
                                                            onChange={handleChange('organization')}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="sales-input-website" lg={3}>Website</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            type="text"
                                                            name="website"
                                                            id="sales-input-website"
                                                            placeholder="gryffindor.org"
                                                            value={form.website}
                                                            onChange={handleChange('website')}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="sales-input-members" lg={3}>Members</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            type="select"
                                                            name="select"
                                                            id="sales-input-members"
                                                            value={form.members}
                                                            onChange={handleChange('members')}
                                                            disabled={loading}
                                                            >
                                                            <option>Less than 1000</option>
                                                            <option>1000 to 4000</option>
                                                            <option>4000 to 10000</option>
                                                            <option>Greater than 10000</option>
                                                        </Input>
                                                    </Col>
                                                </FormGroup>
                                                <hr/>
                                                <FormGroup row>
                                                    <Label for="sales-input-message" lg={3}>Leave us a message</Label>
                                                    <Col lg={9}>
                                                        <Input
                                                            type="textarea"
                                                            name="message"
                                                            id="sales-input-message"
                                                            value={form.message}
                                                            onChange={handleChange('message')}
                                                            disabled={loading}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                <Row>
                                                    <Col className="text-right">
                                                        <Button
                                                            className="mt-4"
                                                            color="primary"
                                                            type="button"
                                                            onClick={postForm}
                                                            disabled={loading}
                                                            >
                                                            Contact Sales
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                {(errorMessage) &&
                                                    <Alert color="danger" className="mt-4">
                                                        <strong>Warning!</strong> {errorMessage} 
                                                    </Alert>
                                                }
                                            </Form>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md="0" lg="5" className="pt-6 text-center">
                                <div className="d-inline-block text-left w-75">
                                    <h4>
                                        Our Sales Team can
                                    </h4>
                                    <p className="lead mb-0">
                                        Give in-depth insight in to the Software
                                    </p>
                                    <p className="lead mt-2 mb-0">
                                        Align your goals with Club Apps capabilities
                                    </p>
                                    <p className="lead mt-2 mb-0">
                                        Provide tools to get your membership online
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section">
                    <Container className="py-5">
                        <Row>
                            <Col md="6">
                                <div className="d-flex px-3">
                                    <div>
                                        <div className="icon icon-lg icon-shape bg-white shadow rounded-circle">
                                            <i className="ni ni-support-16 text-warning" />
                                        </div>
                                    </div>
                                    <div className="pl-4">
                                        <h4 className="text-warning">Technical or Account Support</h4>
                                        <p className="mt-2">
                                            Looking for technical support or need an an account specialist?&nbsp;
                                            <a href="https://support.clubapps.org">Visit Support</a>.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md="6">
                                <div className="d-flex px-3">
                                    <div>
                                        <div className="icon icon-lg icon-shape bg-white shadow rounded-circle">
                                            <i className="ni ni-email-83 text-success" />
                                        </div>
                                    </div>
                                    <div className="pl-4">
                                        <h4 className="text-success">Send us an Email</h4>
                                        <p className="mt-2">
                                            Would you prefer to email us directly? Reach us at&nbsp;
                                            <a href="mailto:sales@clubapps.org">sales@clubapps.org</a>.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <SimpleFooter/>
        </Fragment>
    )
}
